module.exports = __webpack_public_path__ + "img/green-energy.e790c43.png";